// Replace page-specific metadata as a unit. Restoring the initial document's
// tags on unmount would restore the wrong page after client-side navigation.
const PAGE_TAGS = [
  'meta[name="title"]',
  'meta[name="description"]',
  'meta[name="robots"]',
  'meta[name^="twitter:"]',
  'meta[property^="og:"]',
  'meta[property^="article:"]',
  'link[rel="canonical"]',
  '[data-page-seo]',
  '[data-blog-seo]',
].join(',');

export const applyPageHead = ({ title, meta = [], link = [] }, jsonLd = []) => {
  if (typeof document === 'undefined') return;

  document.head.querySelectorAll(PAGE_TAGS).forEach((node) => node.remove());
  document.title = title;

  for (const tag of meta) {
    const node = document.createElement('meta');
    node.setAttribute(tag.name ? 'name' : 'property', tag.name || tag.property);
    node.setAttribute('content', tag.content);
    node.setAttribute('data-page-seo', '');
    document.head.appendChild(node);
  }
  for (const tag of link) {
    const node = document.createElement('link');
    node.setAttribute('rel', tag.rel);
    node.setAttribute('href', tag.href);
    node.setAttribute('data-page-seo', '');
    document.head.appendChild(node);
  }
  for (const block of jsonLd) {
    const node = document.createElement('script');
    node.type = 'application/ld+json';
    node.textContent = JSON.stringify(block);
    node.setAttribute('data-page-seo', '');
    document.head.appendChild(node);
  }
};
